const animate = () => {
    $('.product-puff__animate').each(function(i){

        const elementPosition = $(this).position().top;
        const windowPosition = $(window).scrollTop() + $(window).height();

        let item = this

        if(elementPosition < windowPosition) {

            setTimeout(function(){
                item.classList.add('animated');
                item.classList.add('slideInUp');
                item.classList.add('show');
            }, (i+1) * 40);

        }

    });
}

const events = () => {
    if ($(window).width() > 640) {
        // $(window).on('scroll', animate);
        window.addEventListener('scroll', animate, { passive: true });
    }
}

const init = () => {
    events();
}

export default init;
